import React from 'react';

import BillingError from '@components/BillingError';

const PAST_DUE_MESSAGE =
  'Your account is currently disabled. Re-join The Information on your existing plan by updating your payment method.';

const PAST_DUE_ERROR = {
  error_code: 'billing_past_due',
  message: PAST_DUE_MESSAGE,
  flow: 'update_payment',
} as const;

const PastDueMessage = () => (
  <div id="resurrect-card">
    <div className="top">
      <h1 className="title">Re-Enable The Information</h1>
      <BillingError error={PAST_DUE_ERROR} className="title-sub" />
    </div>
  </div>
);

export default PastDueMessage;
